export const ADMISSION_VERIFY_ANSWERS_ROUTE = "/workflow/verify";
